import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseActions } from '../BaseActions';
import { AddToCartActionOption, CartEvents } from '@wix/wixstores-client-core';
import { getLeanGQLCartFromCartV1 } from '../../viewer-script/current-cart-service/getLeanGQLCartFromCartV1';
import { getLeanGQLCartFromCart } from '../../viewer-script/current-cart-service/getLeanGQLCartFromCart';
import { SPECS } from '../../constants';
var TinyCartActions = /** @class */ (function (_super) {
    __extends(TinyCartActions, _super);
    function TinyCartActions(_a) {
        var siteStore = _a.siteStore, origin = _a.origin, context = _a.context;
        var _this = _super.call(this, { siteStore: siteStore, origin: origin }) || this;
        _this.context = context;
        return _this;
    }
    TinyCartActions.prototype.showTinyCart = function (_a) {
        var _b = _a === void 0 ? {} : _a, addedProductId = _b.addedProductId;
        return __awaiter(this, void 0, void 0, function () {
            var leanGQLCartModel;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getLeanGQLCartFromCart({
                                currentCartService: this.context.currentCartService,
                                wixApi: this.context.wixApi,
                                platformServices: this.context.platformServices,
                            })];
                    case 1:
                        leanGQLCartModel = _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getLeanGQLCartFromCartV1(this.context.currentCartService)];
                    case 3:
                        leanGQLCartModel = _c.sent();
                        _c.label = 4;
                    case 4:
                        if (addedProductId) {
                            this.siteStore.pubSubManager.publish(CartEvents.CHANGED, __assign(__assign({}, leanGQLCartModel), { extraParams: { origin: 'ShowTinyCart' }, eventOptions: {
                                    shouldOpenCart: true,
                                    addToCartActionOption: AddToCartActionOption.TINY_CART,
                                    addedProductId: addedProductId,
                                    originatedInWorker: true,
                                }, reason: 'ShowTinyCart' }));
                        }
                        else {
                            this.siteStore.pubSubManager.publish('Tinycart.Show', null);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TinyCartActions.prototype.hideTinyCart = function () {
        this.siteStore.pubSubManager.publish('Tinycart.Hide', null);
    };
    return TinyCartActions;
}(BaseActions));
export { TinyCartActions };
//# sourceMappingURL=TinyCartActions.js.map